import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/contact", "fr", "contact");
